import { Button, ConfirmPopover, Typography, usePersistenceObjectUpdate } from '@fox/atoms';
import { ImportContextState, ImportState } from '@fox/import-core';
import { useContentContext } from '../../content-context';
import { useUpsertImportDoc } from '../mutation-hooks/mutation-implementations';
import { useImporterContext } from './importer-context';

export function ImportButton({
	state,
	importState,
	onClick
}: {
	state: ImportContextState;
	importState: ImportState;
	onClick: () => void;
}) {
	const { contentId, requestToken } = useContentContext();
	const { batchId, financialOptions, linkedOrganisationDetails } = useImporterContext();
	const { updateData } = usePersistenceObjectUpdate();
	const totalPriceInDollars = state?.data?.length ? (state.data.length * financialOptions.pricePerRow) / 100 : undefined;

	const { mutate: upsertImportDoc } = useUpsertImportDoc({ requestToken });

	return (
		<ConfirmPopover
			disabled={importState !== ImportState.Idle || state?.data?.length < 1}
			message={
				<Typography>
					Are you sure you would like to be invoiced <b>${totalPriceInDollars?.toLocaleString()}</b> and start the import?
				</Typography>
			}
			confirm={async () => {
				await upsertImportDoc({
					contentId,
					id: batchId,
					organisationId: linkedOrganisationDetails.organisationId,
					completed: true
				});
				onClick();
				updateData(null);
			}}
		>
			<Button variant="primary" disabled={importState !== ImportState.Idle || state?.data?.length < 1}>
				Import
			</Button>
		</ConfirmPopover>
	);
}
